import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPageTextAndImage = function LandingPageTextAndImage(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "px-4 md:px-0 mx-auto max-w-full md:max-w-threequarters",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-column md:flex-row md:justify-center",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-column justify-center mb-8 md:mr-16 w-full md:w-1/3",
        children: [/*#__PURE__*/_jsx("div", {
          className: "font-serif text-2xl md:text-2rem leading-snug md:leading-snug text-gray-900",
          children: props.title
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-4 font-dmsans text-xl leading-snug md:leading-snug text-gray-900",
          children: props.description
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "",
        children: /*#__PURE__*/_jsx("img", {
          className: "w-full",
          src: props.imageHref
        })
      })]
    })
  });
};

export default LandingPageTextAndImage;